import script from "./PpeRequestCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./PpeRequestCompleted.vue?vue&type=script&setup=true&lang=js"

import "./PpeRequestCompleted.vue?vue&type=style&index=0&id=09f7498e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f7498e"]])

export default __exports__